<template>
    <PublicLandingPage :page="landingPages.birthdayCakes" />
</template>

<script setup lang="ts">
import { landingPages } from '~/fixtures';
</script>
